module.exports = __webpack_public_path__ + "static/img/swiper3.a8128a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiper3.png
// module id = g+bV
// module chunks = 0